export const franchisees = [
  {
    id: 'pr',
    estado: 'PARANÁ | PR',
    representantes: [
      
      {
        nome: 'Ponto TV Curitiba',
        local: 'Curitiba, Araucária, Campina Grande do Sul e Campo Largo',
        franqueado: 'Juliano Pimentel',
        telefone: '(41) 99257-6534',
        facebook: '@pontotvcwb',
        instagram: '@pontotvcwb'
      },
      { 
        nome: 'Ponto TV Colombo',
        local: 'Colombo',
        franqueado: 'Juliano Pimentel',
        telefone: '(41) 99257-6534',
        facebook: '@pontotvcwb',        
        instagram: '@pontotvcwb'
      },
      { 
        nome: 'Ponto TV Pinhais',
        local: 'Pinhais',
        franqueado: 'Juliano Pimentel',
        telefone: '(41) 99257-6534',
        facebook: '@pontotvcwb',      
        instagram: '@pontotvcwb',
      },
      { 
        nome: 'Ponto TV São José dos Pinhais',
        local: 'São José dos Pinhais ',
        franqueado: 'Juliano Pimentel',
        telefone: '(41) 99257-6534',      
        instagram: '@pontotvtamandare'
      },  
      { 
        nome: 'Ponto TV Almirante Tamandaré',
        local: 'Almirante Tamandaré, Itaperuçu e Rio Branco do Sul ',
        franqueado: 'Joel Anselmo',
        telefone: '(41) 99828-7119',      
        instagram: '@pontotvtamandare'
      },
      {
        nome: 'Ponto TV Fazenda Rio Grande',
        local: 'Fazenda Rio Grande',
        franqueada: 'Solange Galbiati',
        telefone: '(41) 92000-7880',
        facebook: '@pontotvfazendariogrande',
        instagram: '@pontotvfazendariogrande'
      },
      {
        nome: 'Ponto TV Ponta Grossa',
        local: 'Ponta Grossa',
        franqueado: 'Juliano Pimentel',
        telefone: '(41) 99257-6534',
        facebook: '@pontotvcwb',
        instagram: '@pontotvcwb'
      },
      {
        nome: 'Ponto TV Foz do Iguaçu',
        local: 'Foz do Iguaçu',
        franqueado: 'Juliano Pimentel',
        telefone: '(41) 99257-6534',
        facebook: '@pontotvcwb',
        instagram: '@pontotvcwb'        
      },
      {
        nome: 'Ponto TV Londrina',
        local: 'Londrina, Arapongas e Rolândia ',
        franqueado: 'Juliano Pimentel',
        telefone: '(41) 99257-6534',
        facebook: '@pontotvcwb',
        instagram: '@pontotvcwb'
      },         
      {
        nome: 'Ponto TV Interior',
        local: 'Prudentópolis, Guarapuava, Pato Branco, Medianeira, Jandaia do Sul e Francisco Beltrão',
        franqueado: 'Juliano Pimentel',
        telefone: '(41) 99257-6534',
        facebook: '@pontotvcwb',
        instagram: '@pontotvcwb'
      },      
    ]
  },
  {
    id: 'am',
    estado:  'AMAZONAS | AM',
    representantes: []
  },
  {
    id: 'ma',
    estado: 'MARANHÃO | MA',
    representantes: [         
    ]
  },
  {
    id: 'ms',
    estado: 'MATO GROSSO DO SUL | MS',
    representantes: []
  },
  {
    id: 'mg',
    estado: 'MINAS GERAIS | MG',
    representantes: [
      {
        nome: 'Ponto TV Ituiutaba',
        local: 'Ituiutaba',
        franqueado: 'Halysson Rezende',
        telefone: '(34) 99664-4000'
      },
    ]
  },
  {
    id: 'pa',
    estado: 'PARÁ | PA',
    representantes: [
    ]
  },
  {
    id: 'pe',
    estado: 'PERNAMBUCO | PE',
    representantes: []
  },
  {
    id: 'rj',
    estado: 'RIO DE JANEIRO | RJ',
    representantes: [      
      { 
        nome: 'Ponto TV Macaé',
        local: 'Macaé',
        franqueado: 'Thiago Guerra Marques',
        telefone: '(21) 97141-9611',      
        instagram: '@pontotvmacae'
      },
      {
        nome: 'Ponto TV Cabo Frio',
        local: 'Cabo Frio',
        franqueado: 'Breno Jotha Rodrigues',
        telefone: '(22) 98839-8137',        
        instagram: '@pontotvcabofrio'
      },      
    ]
  },
  {
    id: 'sp',
    estado: 'SÃO PAULO | SP',
    representantes: [
      {
        nome: 'Ponto TV Campinas',
        local: 'Campinas e regiões',
        franqueado: 'Rodrigo Diniz',
        telefone: '(19) 99430-0770',
        instagram: '@pontotvcampinas'
      },
      {
        nome: 'Ponto TV Indaiatuba',
        local: 'Indaiatuba e regiões',
        franqueado: 'José A. Machado',
        telefone: '(19) 98937-8108',
        instagram: '@pontotvindaiatuba'
      },
      {
        nome: 'Ponto TV Itu',
        local: 'Itu e regiões',
        franqueado: 'Fernando Lima',
        telefone: '(11) 94910-6571',
        instagram: '@pontotvitu'
      },
      {
        nome: 'Ponto TV Valinhos',
        local: 'Valinhos e regiões',
        franqueado: 'Fernando Lima',
        telefone: '(11) 94910-6571',
        instagram: '@pontotvvalinhos'
      },
    ]
  },   
  {
    id: 'ac',
    estado: 'ACRE | AC',
    representantes: []
  },
  {
    id: 'al',
    estado: 'ALAGOAS | AL',
    representantes: []
  },  
  {
    id: 'ap',
    estado: 'AMAPÁ | AP',
    representantes: []
  },
  {
    id: 'ba',
    estado: 'BAHIA | BA',
    representantes: [      
    ]
  },
  {
    id: 'ce',
    estado: 'CEARÁ | CE',
    representantes: []
  },
  {
    id: 'es',
    estado: 'ESPÍRITO SANTO | ES',
    representantes: []
  },
  {
    id: 'go',
    estado: 'GOIÁS | GO',
    representantes: []
  }, 
  {
    id: 'mt',
    estado: 'MATO GROSSO | MT',
    representantes: []
  },  
  {
    id: 'pb',
    estado: 'PARAÍBA | PB',
    representantes: []
  },
  {
    id: 'pi',
    estado: 'PIAUÍ | PI',
    representantes: []
  },
  {
    id: 'rn',
    estado: 'RIO GRANDE DO NORTE | RN',
    representantes: []
  },
  {
    id: 'ro',
    estado: 'RORAIMA | RO',
    representantes: []
  },
  {
    id: 'rr',
    estado: 'RIO BRANCO | RR',
    representantes: []
  },
  {
    id: 'rs',
    estado: 'RIO GRANDE DO SUL | RS',
    representantes: []
  },
  {
    id: 'sc',
    estado: 'SANTA CATARINA | SC',
    representantes: [
      { 
        nome: 'Ponto TV SC',
        local: 'Balneário Camboriú e Joinville',
        franqueado: 'Juliano Pimentel',
        telefone: '(41) 99257-6534',
        facebook: '@pontotvcwb',  
        instagram: '@pontotvcwb'
      },
    ]
  },
  {
    id: 'se',
    estado: 'SERGIPE | SE',
    representantes: []
  },
  
  {
    id: 'to',
    estado: 'TOCANTINS | TO',
    representantes: []
  },
  {
    id: 'bs',
    estado: 'BRASILIA | BSB',
    representantes: []
  },
]